/**
 * @generated SignedSource<<a6e61915d0d64aaa865f242dea93b12a>>
 * @relayHash 2bf8d62dc6c5873c241a7411c81c16ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fe8907d2399e24d926245722555453f9c22ffceae0abb8d339c68a0ecc7949de

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CommitDetailsPopupViewCommitDetailsPopupViewQuery } from './CommitDetailsPopupViewCommitDetailsPopupViewQuery.graphql';

const node: PreloadableConcreteRequest<CommitDetailsPopupViewCommitDetailsPopupViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fe8907d2399e24d926245722555453f9c22ffceae0abb8d339c68a0ecc7949de",
    "metadata": {},
    "name": "CommitDetailsPopupViewCommitDetailsPopupViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
